import {
  TimeQuestionConfig,
  TimeResponseState,
  TimeType,
} from '@gripp/shared-logic';
import { FC } from 'react';
import { RoutineQuestionExecutionFormProps } from '../../types';
import { DateOnly } from './dateOnly';
import { StartEndTime } from './startEndTime';
import { TimeAndDate } from './timeAndDate';
import { TimeOnly } from './timeOnly';

type TimeFormTypeComponent = FC<
  RoutineQuestionExecutionFormProps<TimeQuestionConfig, TimeResponseState>
>;
export const TimeFormTypeComponents: Record<TimeType, TimeFormTypeComponent> = {
  [TimeType.StartEndTimes]: StartEndTime,
  [TimeType.TimeOnly]: TimeOnly,
  [TimeType.DateOnly]: DateOnly,
  [TimeType.TimeAndDate]: TimeAndDate,
};
